
import React, { ReactNode } from "react";
import PageLayout from "./PageLayout";
import { AdminBackBreadcrumb } from "@/components/dashboard/AdminBackBreadcrumb";
import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { useLocation } from "react-router-dom";
import { useProfileQuery } from "@/hooks/useProfileQuery";
import { Spinner } from "@/components/ui/spinner";

interface AdminLayoutProps {
  children: ReactNode;
  title?: string;
  showSidebar?: boolean;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  title,
  showSidebar = false
}) => {
  const location = useLocation();
  const { data: userProfile, isLoading } = useProfileQuery();
  const isAdminHome = location.pathname === "/admin";

  const renderTitle = () => {
    if (isLoading) {
      return <Spinner size="sm" />;
    }

    if (userProfile) {
      return (
        <h2 className="text-[#9b87f5] text-3xl font-bold">
          Welcome, {userProfile.first_name || 'User'}
          {userProfile.role && (
            <span className="text-2xl ml-2 text-gray-600">
              ({userProfile.role})
            </span>
          )}
        </h2>
      );
    }

    return title ? <h2 className="text-[#9b87f5]">{title}</h2> : null;
  };

  return (
    <PageLayout>
      {showSidebar ? (
        <SidebarProvider>
          <div className="flex min-h-screen w-full flex-col md:flex-row bg-gradient-to-br from-white via-[#F7F5FF] to-[#E5DEFF]/50">
            <DashboardSidebar />
            <div className="flex-1 p-4 md:p-8 overflow-x-auto">
              {!isAdminHome && <AdminBackBreadcrumb />}
              {children}
            </div>
          </div>
        </SidebarProvider>
      ) : (
        <div className="container mx-auto px-4 py-6">
          <div className="mb-8">
            {!isAdminHome && <AdminBackBreadcrumb />}
            {renderTitle()}
          </div>
          {children}
        </div>
      )}
    </PageLayout>
  );
};

export default AdminLayout;
